import React, { FC } from 'react'
import { CommonTitleSectionContainer } from '../styled';
import { TextField, Grid } from '@mui/material';

type CalculationInputProps = {
    isLessThan1280: boolean,
    methods: any,
    setRedoState(redoState: any): void
}

const CalculationInput: FC<CalculationInputProps> = ({ isLessThan1280, methods, setRedoState }) => {

    return (
        <React.Fragment>
            <Grid container spacing={1.5} alignItems="flex-start">
                <Grid item xs={7.5}>
                    <CommonTitleSectionContainer 
                        isLargeScreen={!isLessThan1280} 
                        sx={{ marginRight: 0, whiteSpace: 'nowrap', marginBottom: '8px !important' }}
                    >
                        Calculation rules
                    </CommonTitleSectionContainer>
                    <TextField
                        id="calculationRulesId"
                        placeholder="Type here"
                        {...methods.register(
                            "calculationRules"
                        )}
                        value={methods.watch(
                            "calculationRules"
                        ) ?? ""}
                        onChange={(e: any) => {
                            methods.setValue(
                                "calculationRules",
                                e.target.value
                            );
                            methods.clearErrors();
                            setRedoState([]);
                        }}
                        fullWidth
                        size="small"
                    />
                </Grid>
                <Grid item xs={4.5}>
                    <CommonTitleSectionContainer 
                        isLargeScreen={!isLessThan1280} 
                        sx={{ marginRight: 0, whiteSpace: 'nowrap', marginBottom: '8px !important' }}
                    >
                        Max Decimal
                    </CommonTitleSectionContainer>
                    <TextField
                        type="number"
                        size="small"
                        inputProps={{ min: 0, max: 9 }}
                        sx={{ '& .MuiInputBase-input': { textAlign: 'center' } }}
                        {...methods.register("maxDecimal")}
                        value={methods.watch("maxDecimal") ?? 2}
                        onChange={(e: any) => {
                            let val = parseInt(e.target.value);
                            if (isNaN(val)) val = 0;
                            if (val < 0) val = 0;
                            if (val > 9) val = 9;
                            methods.setValue("maxDecimal", val);
                            methods.clearErrors();
                            setRedoState([]);
                        }}
                        fullWidth
                    />
                </Grid>
            </Grid>
        </React.Fragment>
    )
}

export default CalculationInput